import type { WebSearchProvider } from "@rally/agreed";
import type { BrandName, IconName } from "@rally/ui-kit";
import type { Word } from "../localization/say.ts";

export const INTEGRATION_KINDS = ["ai", "social", "search", "shopping", "travel"] as const;
export type IntegrationKind = (typeof INTEGRATION_KINDS)[number];

export type SearchSubject = {
  provider: WebSearchProvider;
  name: string;
  mark: BrandName | null;
  icon?: IconName;
};

export const SEARCH_SUBJECTS: readonly SearchSubject[] = [
  { provider: "brave", name: "Brave Search", mark: "brave" },
  { provider: "exa", name: "Exa", mark: null, icon: "search" },
  { provider: "tavily", name: "Tavily", mark: null, icon: "search" },
  { provider: "openai", name: "OpenAI web search", mark: "openai" },
];

export type Coming = {
  id: string;
  kind: IntegrationKind;
  name: string;
  mark: BrandName | null;
  icon?: IconName;
  whatKey: Word;
};

export const COMING: readonly Coming[] = [
  {
    id: "amazon",
    kind: "shopping",
    name: "Amazon",
    mark: null,
    icon: "shopping-bag",
    whatKey: "integrations.coming.amazon",
  },
  { id: "airbnb", kind: "travel", name: "Airbnb", mark: "airbnb", whatKey: "integrations.coming.airbnb" },
  {
    id: "booking",
    kind: "travel",
    name: "Booking.com",
    mark: "booking",
    whatKey: "integrations.coming.booking",
  },
];
